<template>
  <div class="row filters-container">
    <div class="col-12">
      <div class="row mb-2">
        <div class="col-12">
          <div class="float-right">
            <b-link
              v-if="filterConfigModel.extraFilters.length"
              v-b-toggle.collapse-1-inner
              class="mr-2"
              @click="showAll = !showAll"
            >
              <BIconFunnel />
              {{ (showAll ? 'less_filters' : 'more_filters') | i18n }}
            </b-link>
            <b-link
              @click="clearAll"
            >
              <BIconX />
              {{ 'clear_all' | i18n }}
            </b-link>
          </div>
        </div>
      </div>
      <div
        class="row filters-row"
        :class="{'show-all': showAll}"
      >
        <!-- Main filters -->
        <div
          v-for="mainFilter in filterConfigModel.mainFilters"
          :key="mainFilter.key"
          class="col-12 col-sm-6 col-lg-3 col-xl-2 filter-wrapper"
        >
          <b-form-group
            id="customer-number"
            :label="mainFilter.label | i18n"
            :label-for="mainFilter.key + '__filter_input'"
          >
            <table-filter
              :id="mainFilter.key + '__filter_input'"
              v-model="filterModel[mainFilter.key]"
              :input-type="mainFilter.inputType"
              :filter-options="mainFilter.filterOptions"
            />
          </b-form-group>
        </div>
        <!--/ Main filters END -->
        <!-- Secondary filters -->
        <div
          v-for="extraFilter in filterConfigModel.extraFilters"
          :key="extraFilter.key"
          class="col-12 col-sm-6 col-lg-3 col-xl-2 extra-filter"
          :class="showAll ? 'extra-filter-show' : 'extra-filter-hide'"
        >
          <b-form-group
            :id="extraFilter.key"
            :label="extraFilter.label | i18n"
            :label-for="extraFilter.key + '__filter_input'"
          >
            <table-filter
              :id="extraFilter.key + '__filter_input'"
              v-model="filterModel[extraFilter.key]"
              :input-type="extraFilter.inputType"
              :filter-options="extraFilter.filterOptions"
            />
          </b-form-group>
        </div>
        <!--/ Secondary filters END -->
      </div>
    </div>
  </div>
</template>

<script>
import TableFilter from './table-filter';
import { BIconFunnel, BIconX, VBToggle } from 'bootstrap-vue';

export default {
  name: 'Filters',
  components: {TableFilter, BIconFunnel, BIconX},
  directives: {
    'b-toggle': VBToggle
  },
  props: {
    filter: {
      type: Object,
      default: () => {
      }
    },
    filterConfig: {
      type: Object,
      default: () => ({
        mainFilters: [],
        extraFilters: []
      })
    }
  },
  data: function () {
    return {
      filterModel: {},
      filterConfigModel: {
        mainFilters: [],
        extraFilters: []
      },
      showAll: false
    };
  },
  watch: {
    filterModel(newVal) {
      this.$emit('input', newVal);
    }
  },
  created() {
    this.filterModel = {...this.filter};

    if (this.filterConfig.mainFilters) {
      this.filterConfigModel.mainFilters = [].concat(this.filterConfig.mainFilters);
    }

    if (this.filterConfig.extraFilters) {
      this.filterConfigModel.extraFilters = [].concat(this.filterConfig.extraFilters);
    }
  },
  methods: {
    clearAll() {
      Object.keys(this.filterModel).forEach(key => this.filterModel[key] = null);
      this.$emit('input', this.filterModel);
    }
  }
};
</script>

<style scoped lang="scss">
    * {
        font-size: 0.875rem;
    }

    .filters-container {
        padding: 10px 25px;
    }

    ::v-deep   .form-group {
        margin-bottom: 10px;

        label {
            margin-bottom: 4px;
        }
    }

    .toggle-button-container {
        position: absolute;
        top: 10px;
        right: 10px;
    }

    .extra-filter {
        transition: all .1s linear;
    }

    .extra-filter-show {
        opacity: 1;
        height: auto;
        width: auto;
    }

    .extra-filter-hide {
        opacity: 0;
        height: 0;
        width: 0;
    }

    .filters-row {
        height: 72px;
        overflow: hidden;
        transition: height .3s linear;

        &.show-all {
            height: 138px;
            transition: height .3s linear;
        }

        @media (max-width: 1200px) {
            &.show-all {
                height: 205px;
            }
        }

        @media (max-width: 992px) {
            height: 138px;

            &.show-all {
                height: 338px;
            }
        }

        @media (max-width: 576px) {
            height: 205px;

            &.show-all {
                height: 675px;
            }
        }
    }
</style>
